"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const Dialog = require("../shared/Dialog/DialogActions");
const api_1 = require("../api");
const LoadingSpinner_1 = require("../shared/LoadingSpinner");
class OrganizationUserAccept extends React.Component {
    render() {
        return React.createElement(LoadingSpinner_1.default, null);
    }
    componentDidMount() {
        let token = this.props.params.token;
        api_1.doPost(api_1.API.v2.ORGANIZATION.REQUESTS.USER.ACTIVATE(), { token: token }).then(response => {
            this.showSuccessDialog();
        }).catch(error => {
            this.showFailedDialog();
        });
    }
    showSuccessDialog() {
        Dialog.showAlertDialog({
            title: "Success",
            message: "You have accepted this user"
        });
    }
    showFailedDialog() {
        Dialog.showAlertDialog({
            title: "Error",
            message: "Something went wrong. Try again later."
        });
    }
}
exports.default = OrganizationUserAccept;


//////////////////
// WEBPACK FOOTER
// ./client/src/landing/OrganizationUserAccept.tsx
// module id = 1350
// module chunks = 0 1